<nav class="nav-wrapper">
    <div id="nav" class="nav-bar" [ngClass]="{'apple-device': isNavIOS}">
        
        <div class="left" [ngClass]="{'back-btn-active': appState.navigation.backButtonState()}">
            <div class="nav-brand">
                <app-svg-loader *ngIf="currentTheme === 'dark-theme'" [height]="getLogoSize()" url="assets/logos/tail-one-logo-white.svg"></app-svg-loader>
                <app-svg-loader *ngIf="currentTheme === 'light-theme'" [height]="getLogoSize()" url="assets/logos/tail-one-logo-dark.svg"></app-svg-loader>
            </div>
        </div>

        <div class="right">
            <app-nav-user-widget [limited]="true"></app-nav-user-widget>
        </div>
    </div>
</nav>
